<template>
<div>
    <Slide :pageOption="pageOption" />
    <div v-if="item" class="mt-5 animate__animated animate__fadeIn">
        <v-card max-width="1200" class="mx-auto" v-if="memberOnly(item)">
            <v-card-text class="itemHeader">
                <h1>{{item.title}}</h1>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-text class="animate__animated animate__fadeIn" >
                
                <NotAllow :item="item" />
                <Html :item="item" :pageOption="pageOption" v-if="item.mode != 'notAllow'" />

            </v-card-text>

        </v-card>
    </div>

</div>
</template>

<script>
export default {

    components: {

    },

    data: () => ({

        item: null,
        pageOption: null,

    }),

    watch: {

    },
    methods: {

        getMainPage() {
            let data = {}
            data.slug = this.slug
            const formData = this.$formData(
                data
            );
            let url = "page/mainPage";
            let $vm = this;
            this.$API
                .post(url, this.formData(formData))
                .then(function (res) {
                    $vm.checkApi(res);
                    $vm.item = res.data.item
                    $vm.pageOption = res.data.pageOption
                    if(res.data.item) { 
                    if(res.data.item.type == 'main') {
                        $vm.$MEMBER_ONLY_TEXT = null
                    }
                    }

                })
                .catch(function (error) {
                    console.log(error);
                });

        },

    },
    created() {

        this.getMainPage()

    },
};
</script>
